import { DestroyRef, inject, Injectable, signal } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { fromEvent, Observable } from 'rxjs'
import { map } from 'rxjs/operators'

@Injectable({
  providedIn: 'root',
})
export class NetworkService {
  private destroyRef = inject(DestroyRef)

  private _onLine = signal<boolean>(navigator.onLine)
  public onLine = this._onLine.asReadonly()

  // fires only on the offline -> online transition, so consumers can retry
  // requests that failed or were skipped while the network was down
  public reconnected$: Observable<void> = fromEvent(window, 'online').pipe(
    map(() => undefined),
  )

  public disconnected$: Observable<void> = fromEvent(window, 'offline').pipe(
    map(() => undefined),
  )

  constructor() {
    this.checkNetworkStatus()
  }

  checkNetworkStatus() {
    this.reconnected$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this._onLine.set(navigator.onLine)
      })

    this.disconnected$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this._onLine.set(navigator.onLine)
      })
  }
}
